import { uniqBy } from 'lodash'
import { handlerUseStateVmodel } from './handlerUseStateVmodel'

export default function canUseCommonState (mergeOldWithNew = true) {
  return {
    mixins: [handlerUseStateVmodel(mergeOldWithNew)],
    props: {
      useCommon: { type: String, default: null },
      withFields: {type: Array, default: () => []},
      withMinimalInformation: { type: Boolean, default: false },
      withParams: {type: Object, default: () => {}}
    },
    computed: {
      commonLoading () {
        if (!this.useCommon) return false
        const estado = this.$store.state.common[this.useCommon.split('/')[0]]
        return Boolean(estado?.loading && !estado?.items?.length)
      },
      commonLoaded () {
        if (!this.useCommon) return []
        return this.obterEstadoDoCommon()
      },
      state: {
        get () {
          if (!this.useCommon) return this.__state
          return { ...this.__state, loaded: this.commonLoaded }
        },
        set (value) {
          this.__state = value
        }
      }
    },
    created () {
      this.reloadCommonItems()
    },
    methods: {
      reloadCommonItems () {
        if (!this.useCommon) return
        const modulo = this.useCommon.split('/')[0]
        const estado = this.$store.state.common[modulo]
        if (estado?.items?.length || estado?.loading) return
        this.despacharCarga(modulo, Boolean(this.usaPaginacao))
      },
      despacharCarga (modulo, usaPaginacao) {
        const payload = {
          withFields: this.withFields,
          withMinimalInformation: this.withMinimalInformation,
          withParams: this.withParams
        }
        const acao = usaPaginacao ? 'fetchItemsComPaginacao' : 'fetchItems'
        this.$store.dispatch(`common/${modulo}/${acao}`, payload)
      },
      moduloTemListaCompleta () {
        if (!this.useCommon || this.usaPaginacao) return false
        return Boolean(this.$store.state.common[this.useCommon.split('/')[0]]?.items?.length)
      },
      obterEstadoDoCommon () {
        const caminhoParaGetterNaStore = this.useCommon.includes('/')
        const estadoLoadedPassadoNoVmodel = this.__state.loaded || []

        if (estadoLoadedPassadoNoVmodel.length === 0) {
          if (caminhoParaGetterNaStore) {
            return this.$store.getters[`common/${this.useCommon}`] || []
          }
          return this.$store.state.common[this.useCommon]?.items || []
        }

        if (caminhoParaGetterNaStore) {
          return this.obterCommonAPartirDoGetter(estadoLoadedPassadoNoVmodel)
        }
        return this.obterCommonAPartirDoEstado(estadoLoadedPassadoNoVmodel)
      },
      obterCommonAPartirDoGetter (estadoLoadedPassadoNoVmodel) {
        const estadoGetter = this.$store.getters[`common/${this.useCommon}`] || []
        return uniqBy([...estadoGetter, ...estadoLoadedPassadoNoVmodel], 'id')
      },
      obterCommonAPartirDoEstado (estadoLoadedPassadoNoVmodel) {
        const estadoState = this.$store.state.common[this.useCommon]?.items || []
        return uniqBy([...estadoState, ...estadoLoadedPassadoNoVmodel], 'id')
      }
    },
    watch: {
      useCommon () {
        this.reloadCommonItems()
      }
    }
  }
}
